import { modalRenderer } from '~/modal/modalRendererRegistry';
import type { ModalProps } from '~/modal/modalType.enum';
import { MigrateMapsComponent } from './migrateMaps.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MigrateMaps: ModalProps;
  }
}

modalRenderer.register('MigrateMaps', MigrateMapsComponent);
